import React, { useEffect } from 'react'
import { useAtom } from 'infrastructure/state/jotai.wrapper'
import { updateMapAtom } from '../atoms'
import { ItemSelect as ItemSelectUtil } from '../../../utility/ItemSelect'

type ItemIdType = string | number

export function ItemSelect<T extends { id: ItemIdType }>({
  setKey,
  items,
  itemDisplay,
  initialItem,
}: {
  setKey: string
  items: T[]
  itemDisplay: (item: T) => string
  initialItem?: T
}) {
  const [editMap, setEditMap] = useAtom(updateMapAtom)

  const currentId: ItemIdType =
    (editMap[String(setKey)] as ItemIdType) ?? initialItem?.id

  const onValChange = (id: ItemIdType) => {
    setEditMap((prev) => ({ ...prev, [setKey]: id }))
  }

  useEffect(() => {
    setEditMap((prev) => ({
      ...prev,
      [String(setKey)]: currentId,
    }))
  }, [setEditMap, currentId, setKey])

  if (!items.length) return null

  return (
    <ItemSelectUtil
      label={initialItem && itemDisplay(initialItem)}
      items={items}
      currentVal={currentId}
      itemDisplay={itemDisplay}
      itemValue={({ id }) => id}
      onValChange={onValChange}
    />
  )
}

export function StringSelect({
  setKey,
  items,
  initialItem,
}: {
  setKey: string
  items: string[]
  initialItem?: string
}) {
  const idItems = items.map((item) => ({ id: item }))
  const initialItemWithId = idItems.find(({ id }) => id === initialItem)
  return (
    <ItemSelect
      setKey={setKey}
      items={idItems}
      itemDisplay={({ id }) => id}
      initialItem={initialItemWithId}
    />
  )
}
